import { listenForDocusignSigning } from './docusignSigning';
import { ChangeOfferReason } from './voziqOfferFlow.service';
import { VoziqOffer } from './types';

const ChatButtonSelector = '.ie-div-position-customer-chat';

class VoziqSignModalController {
    public resolve: { offer: VoziqOffer, shownOfferIds?: number[] };
    public close: () => void;
    public dismiss: (result?: { $value: string }) => void;

    public isLoading = true;
    public isComplete = false;
    public isFailed = false;
    public docusignUrl: string;

    private stopListening: () => void;

    constructor(private $window: Window, private $scope: ng.IScope, private dataContext: any) {
        'ngInject';
    }

    public $onInit() {
        this.setChatButtonDisplay('none');
        this.stopListening = listenForDocusignSigning(this.$window,
            () => this.$scope.$applyAsync(() => this.isComplete = true),
            () => this.$scope.$applyAsync(() => this.isFailed = true),
            () => this.$scope.$applyAsync(() => this.dismiss()));

        this.dataContext.contractRenewal.getContractSigningUrl(this.resolve.offer.VoziqOfferID, this.resolve.shownOfferIds)
            .then((url: string) => this.docusignUrl = url)
            .catch(() => this.isFailed = true)
            .finally(() => this.$scope.$applyAsync(() => this.isLoading = false));
    }

    public $onDestroy() {
        this.stopListening();
        this.setChatButtonDisplay('block');
    }

    public changeOffer() {
        this.dismiss({ $value: ChangeOfferReason });
    }

    public exit() {
        if (this.isComplete) {
            this.close();
        } else {
            this.dismiss();
        }
    }

    private setChatButtonDisplay(display: string) {
        const chatButton = this.$window.document.querySelector(ChatButtonSelector) as HTMLElement;
        if (chatButton) {
            chatButton.style.display = display;
        }
    }
}

export const voziqSignModal = {
    template: require('./voziqSignModal.html'),
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    controller: VoziqSignModalController
};
